<script>
  import { options } from './ChartOptions.module.svelte';
  import { Card, CardBody, CardSubtitle } from "sveltestrap";
  import Line from "svelte-chartjs/src/Line.svelte";
  export let chartData;
  //export let chartTitle;

  //console.log(chartData);
</script>

<Card>
  <!-- <CardSubtitle>{chartTitle}</CardSubtitle> -->
  <CardBody >
    <Line data={chartData} {options}/>
  </CardBody>
</Card>
